module.exports = __webpack_public_path__ + "img/logo.84735a34.png";